import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { useApp } from "@/contexts/AppContext";
import AppShell from "@/components/common/AppShell";
import DevicesPage from "@/features/devices/pages/DevicesPage";
import DeviceDetailPage from "@/features/devices/pages/DeviceDetailPage";
import AccessTokensPage from "@/pages/AccessTokensPage";
import PixelsPage from "@/features/pixels/pages/PixelsPage";
import PixelDetailPage from "@/features/pixels/pages/PixelDetailPage";
import { Smartphone, Key, Radio, LogOut } from "lucide-react";

export default function ProviderApp() {
  const { currentUser, currentUserType, logout } = useApp();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const sections = [
    {
      heading: "Traffic",
      items: [
        {
          to: "/provider/devices",
          label: "Devices",
          icon: Smartphone,
        },
      ],
    },
    {
      heading: "Data Collection",
      items: [{ to: "/provider/pixels", label: "Pixels", icon: Radio }],
    },
    {
      heading: "Account",
      items: [
        {
          to: "/provider/access-tokens",
          label: "Access Tokens",
          icon: Key,
        },
      ],
    },
  ];

  const routeTitles = {
    "/provider/devices": "Devices",
    "/provider/pixels": "Pixels",
    "/provider/access-tokens": "Access Tokens",
  };

  const sidebarFooter = (
    <div className="flex items-center gap-2 rounded-(--radius-md) border border-(--border-subtle) bg-(--surface-2) px-3 py-2">
      <span
        aria-hidden="true"
        className="inline-flex h-2 w-2 rounded-(--radius-pill) bg-(--status-success)"
      />
      <div className="min-w-0 text-xs">
        <div className="font-semibold text-(--text-primary)">System status</div>
        <div className="text-(--text-muted)">All systems operational</div>
      </div>
    </div>
  );

  return (
    <AppShell
      roleLabel="Provider"
      sections={sections}
      sidebarFooter={sidebarFooter}
      routeTitles={routeTitles}
      user={{ name: currentUser, role: currentUserType }}
      userMenuItems={[{ label: "Logout", icon: LogOut, onClick: handleLogout }]}
    >
      <Routes>
        <Route index element={<Navigate to="/provider/devices" replace />} />
        <Route path="devices" element={<DevicesPage />} />
        <Route path="device/:deviceId" element={<DeviceDetailPage />} />
        <Route path="pixels" element={<PixelsPage />} />
        <Route path="pixels/:uuid" element={<PixelDetailPage />} />
        <Route path="access-tokens" element={<AccessTokensPage />} />
        <Route path="*" element={<Navigate to="/provider/devices" replace />} />
      </Routes>
    </AppShell>
  );
}
